import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Brauchen unsere Mitarbeiter Programmierkenntnisse?',
  answer: 'Nein. Unsere Sprints sind für gemischte Teams konzipiert — von Product Managern über Domain-Experten bis hin zu Entwicklern. Die Resident Engineers übernehmen die technische Implementierung, während Ihr Team den fachlichen Input liefert.'
}, {
  question: 'Was passiert mit dem geistigen Eigentum?',
  answer: 'Klar geregelt: Alles, was in einem dedizierten Firmen-Sprint entsteht, gehört vollständig Ihrem Unternehmen. Bei offenen Community-Workshops entstehen Open-Source-Ergebnisse, die allen zugänglich sind.'
}, {
  question: 'Wie unterscheidet sich das von klassischer IT-Beratung?',
  answer: 'Wir liefern keine Slide-Decks. Am Ende eines Sprints steht ein funktionierender Prototyp und — noch wichtiger — ein Team, das versteht, was es gebaut hat und wie es weitergeht.'
}, {
  question: 'Können wir auch remote teilnehmen?',
  answer: 'Nein, bewusst nicht. Der Kern unseres Konzepts ist die physische Co-Präsenz. Die besten Ergebnisse entstehen, wenn Menschen in einem Raum zusammenarbeiten — mit Whiteboards, spontanen Gesprächen und dem Fokus, den nur ein dedizierter Ort bieten kann.'
}, {
  question: 'Welche Branchen bedient ihr?',
  answer: 'Alle. Unsere Resident Engineers haben Erfahrung in Logistik, Fertigung, Finanzdienstleistungen, Healthcare, Legal Tech und Handel. KI-Methoden sind branchenübergreifend — der Unterschied liegt in den Daten und Use Cases, und die bringen Sie mit.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-[#020611]" data-id="element-174">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-175">
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-heading mb-6" data-id="element-177">
            Häufig gestellte Fragen
          </h2>
        </div>

        <div className="space-y-4" data-id="element-178">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-border bg-surface overflow-hidden" data-id="element-179">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-6 flex items-center justify-between text-left hover:bg-surface-hover transition-colors" data-id="element-180">
                <span className={`font-heading text-lg md:text-xl font-medium transition-colors ${openIndex === index ? 'text-accent' : 'text-foreground'}`} data-id="element-181">
                  {faq.question}
                </span>
                <ChevronDown className={`shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-accent' : 'text-muted'}`} size={24} data-id="element-182" />
              </button>
              <AnimatePresence data-id="element-183">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-184">
                    <div className="px-6 pb-6 text-muted leading-relaxed border-t border-border/50 pt-4" data-id="element-185">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}